import React from "react";
import { useLocation } from "react-router-dom";
import PickRole from "./components/PickRole";
import LoginPage from "./components/LoginPage";

const Login = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryValue = queryParams.get("roleType");

  if (!queryValue) {
    return <PickRole />;
  }

  return <LoginPage />
};

export default Login;
